import groupBy from "lodash.groupby";
import merge from "lodash.merge";
import sumBy from "lodash.sumby";
import meanBy from "lodash.meanby";
import compact from "lodash.compact";
import mapValues from "lodash.mapvalues";
import {
  ANALYSIS,
  CHANGE_STEP,
  CHANGE_ANALYSIS_TAB,
  FETCH_RESULT_SUCCESS,
  FETCH_RESULT,
  FETCH_RESULT_FAILED,
  FETCH_ALL_RESULT,
  FETCH_ALL_RESULT_SUCCESS,
  FETCH_ADMIN_RESULT,
  FETCH_ADMIN_RESULT_SUCCESS,
  DELETE_ADMIN_RESULT,
  DELETE_ADMIN_RESULT_SUCCES,
  DELETE_ADMIN_RESULT_FAILED,
  FETCH_DRIVERS,
  FETCH_DRIVERS_FAILED,
  FETCH_DRIVERS_SUCCESS
} from "./constants";
import { CHANGE_LANGUAGE } from "../preference/constants";
import {
  questionsDK,
  questionsEN,
  questionsDK_TA,
  questionsEN_TA,
  questionsDK_Drivers,
  questionsEN_Drivers,
  questionsDK_Twelvesections,
  questionsEN_Twelvesections,
  categories
} from "../../pages/Evaluation/questions";

const initialState = {
  step: ANALYSIS,
  highlight: "all",
  adminResult: {
    author: {},
    answers: {}
  },
  resultsMap: [],
  dataMap: [],
  drivers: []
};

function fetchAllmodelData(resultsArray, language) {
  var dataMapArray = [];
  resultsArray.forEach(element => {
    let calc = modelData(element, language);
    var obj = {};
    obj["id"] = element.id;
    obj["results"] = calc.result;
    obj["type"] = element.type;
    obj["peer1"] = !!element.peer1;
    obj["peer2"] = !!element.peer2;
    obj["peer3"] = !!element.peer3;
    obj["owner"] = element.author && element.author.fullName;
    obj["groupedByCategory"] = calc.groupedByCategory;
    obj["peer1Name"] = element.peer1Name;
    obj["peer2Name"] = element.peer2Name;
    obj["peer3Name"] = element.peer3Name;

    dataMapArray.push(obj);
  });

  return dataMapArray;
}
function modelData(results, language) {
  let questions;
  let getKeys;

  switch (results.type) {
    case "profile":
      questions = language === "en" ? questionsEN_TA : questionsDK_TA;

      getKeys = key =>
        language
          ? categories["profile"][key][language]
          : categories["profile"][key].dk;

      break;

    case "twentyfivesections":
      questions = language === "en" ? questionsEN_Drivers : questionsDK_Drivers;

      getKeys = key =>
        language
          ? categories["twentyfivesections"][key][language]
          : categories["twentyfivesections"][key].dk;

      break;

    case "twelvesections":
      const questionsHolder =
        language === "en"
          ? questionsEN_Twelvesections
          : questionsDK_Twelvesections;

      Object.keys(questionsHolder).forEach(
        x => (questions = merge(questions, questionsHolder[x]))
      );

      getKeys = key =>
        language
          ? categories["twelvesections"][key][language]
          : categories["twelvesections"][key].dk;

      break;
    default:
      questions = language === "en" ? questionsEN : questionsDK;
      getKeys = key =>
        language ? categories["360"][key][language] : categories["360"][key].dk;
  }

  const peer1 = mapValues(results.peer1, item => ({ peer1: item.value }));
  const peer2 = mapValues(results.peer2, item => ({ peer2: item.value }));
  const peer3 = mapValues(results.peer3, item => ({ peer3: item.value }));

  const merged = merge(results.answers, questions, peer1, peer2, peer3);

  const groupedByCategory = groupBy(merged, "category");
  const calculatedResult = Object.keys(groupedByCategory).map(key => {
    const own = sumBy(groupedByCategory[key], "value");
    const peer1 = sumBy(groupedByCategory[key], "peer1");
    const peer2 = sumBy(groupedByCategory[key], "peer2");
    const peer3 = sumBy(groupedByCategory[key], "peer3");
    const type = results.type;
    const peer1Count = peer1
      ? peer1 / groupedByCategory[key].length
      : undefined;
    const peer2Count = peer2
      ? peer2 / groupedByCategory[key].length
      : undefined;
    const peer3Count = peer3
      ? peer3 / groupedByCategory[key].length
      : undefined;
    const ownCount = own ? own / groupedByCategory[key].length : undefined;
    const peerAverage = meanBy(compact([peer1Count, peer2Count, peer3Count]));
    return {
      key: getKeys(key),
      type: type,
      categoryKey: key,
      own: ownCount,
      peer1: peer1Count,
      peer2: peer2Count,
      peer3: peer3Count,
      category: key,
      peerAverage,
      difference: Math.abs(peerAverage - ownCount)
    };
  });

  return { result: calculatedResult, groupedByCategory };
}

export default function results(state = initialState, action) {
  switch (action.type) {
    case CHANGE_STEP:
      return {
        ...state,
        step: action.payload.step
      };
    case CHANGE_ANALYSIS_TAB:
      return {
        ...state,
        highlight: action.payload.tab
      };
    case FETCH_RESULT:
      return {
        ...state,
        loading: true
      };
    case FETCH_RESULT_SUCCESS:
      const calc = modelData(action.payload.data, state.language);

      return {
        ...state,
        result: calc.result,
        peer1: !!action.payload.data.peer1,
        peer2: !!action.payload.data.peer2,
        peer3: !!action.payload.data.peer3,
        type: action.payload.type,
        owner:
          action.payload.data.author && action.payload.data.author.fullName,
        ownerEmail:
          action.payload.data.author && action.payload.data.author.email,
        loading: false,
        transactionalAnalysisId: action.payload.data.transactionalanalysisId,
        groupedByCategory: calc.groupedByCategory,
        peer1Name: action.payload.data.peer1Name,
        peer2Name: action.payload.data.peer2Name,
        peer3Name: action.payload.data.peer3Name
      };
    case FETCH_RESULT_FAILED:
      return {
        ...state,
        error: true,
        loading: true
      };

    case FETCH_DRIVERS:
      return {
        ...state,
        loading: true
      };
    case FETCH_DRIVERS_SUCCESS:
      return {
        ...state,
        loading: false,
        drivers: fetchAllmodelData(action.payload.data, state.language)
      };

    case FETCH_DRIVERS_FAILED:
      return {
        ...state,
        error: true,
        loading: true
      };

    case CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.payload.language
      };

    case FETCH_ALL_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        resultsMap: action.payload.data,
        dataMap: fetchAllmodelData(action.payload.data, state.language)
      };

    case FETCH_ADMIN_RESULT:
    case FETCH_ALL_RESULT:
      return {
        ...state,
        loading: true
      };
    case FETCH_ADMIN_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        adminResult: {
          ...action.payload.data,

          answers: merge(action.payload.data.answers, questionsDK)
        }
      };

    case DELETE_ADMIN_RESULT:
      return {
        ...state,
        loading: true
      };
    case DELETE_ADMIN_RESULT_SUCCES:
      const newResults = state.resultsMap.filter(
        val => val.id !== action.payload.evaluationId
      );

      const newDataMap = state.dataMap.filter(
        val => val.id !== action.payload.evaluationId
      );

      return {
        ...state,
        resultsMap: newResults,
        dataMap: newDataMap,
        loading: false
      };

    case DELETE_ADMIN_RESULT_FAILED:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/results/reducer.js